require('./em-loading-spinner.scss');

module.exports = {
  bindings: {},
  template: '<div class="em-lds-ring"><div></div><div></div><div></div><div></div></div>'
};